"use strict";
/* DO NOT EDIT THIS FILE:
 * This file is generated by nsr-addon-scheme/gen project.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=CusBase.js.map